class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onSearchFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  getSearchConstraints() {
    return this.input?.form?.dataset.searchConstraints || this.dataset.searchConstraints || '';
  }

  getDisplaySearchTerm(value = this.input?.value || '') {
    const constraints = this.getSearchConstraints();
    const searchTerm = value.trim();

    if (!constraints) return searchTerm;

    return searchTerm.replace(constraints, '').replace(/\s+/g, ' ').trim();
  }

  getConstrainedSearchTerm(value = this.input?.value || '') {
    const constraints = this.getSearchConstraints();
    const searchTerm = this.getDisplaySearchTerm(value);

    if (!constraints || !searchTerm) return searchTerm;
    if (searchTerm.includes(constraints)) return searchTerm;

    return `${searchTerm} ${constraints}`;
  }

  applySearchConstraints() {
    const constraints = this.getSearchConstraints();

    if (!constraints || !this.input) return;

    const displaySearchTerm = this.getDisplaySearchTerm();
    if (!displaySearchTerm) return;

    this.input.value = this.getConstrainedSearchTerm(displaySearchTerm);

    setTimeout(() => {
      this.input.value = displaySearchTerm;
    }, 0);
  }

  onSearchFormSubmit() {
    this.applySearchConstraints();
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
